import React from 'react'

const Bolivia = (props: React.SVGProps<SVGSVGElement>): React.ReactElement => {
    return (
        <svg
            width="45"
            height="40"
            viewBox="0 0 32 30"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...props}
        >
            <mask
                id="x"
                width="32"
                height="30"
                x="1"
                y="1"
                maskUnits="userSpaceOnUse"
            >
                <path
                    fill="#C4C4C4"
                    d="M10 19a9 9 0 1 0 0-18 9 9 0 0 0 0 18Z"
                />
            </mask>
            <g mask="url(#x)">
                <path fill="#BC2433" d="M33.3-1.8H1v7.84h32.3V-1.8Z" />
                <path fill="#F0D633" d="M33.3 6.04H1v7.84h32.3V6.04Z" />
                <path fill="#347B47" d="M33.3 13.88H1v7.84h32.3v-7.84Z" />
            </g>
        </svg>
    )
}

export default Bolivia
